import React, { useState } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import { Link } from 'react-router-dom';  
 
const CustomAttributes = () => {
  const [selectedRowId, setSelectedRowId] = useState(null);
  const [rows, setRows] = useState([
    { id: 1, name: 'John Doe' },
    { id: 2, name: 'Jane Smith' },
    { id: 3, name: 'Michael Johnson' },
    { id: 4, name: 'Emily Brown' },
    { id: 5, name: 'William Wilson' },
  ]);

  const handleEdit = (id) => {
     

  };

  const handleDelete = (id) => {
    

    setRows(rows.filter(row => row.id !== id));
    setSelectedRowId(null);  
  };

  const handleRowClick = (id) => { 
    setSelectedRowId(id === selectedRowId ? null : id);
  };
  const columns = [
    { field: 'id', headerName: 'ID', width: 150 },
    { field: 'name', headerName: 'Name', width: 300 },
     //{ field: 'actions', headerName: 'Action', width: 200 },
  ];
  const [searchTerm, setSearchTerm] = useState('');
  const filteredRows = rows.filter(row =>
    Object.values(row).some(value =>
      value.toString().toLowerCase().includes(searchTerm.toLowerCase())
    )
  );
  return (
          <div>
            <h2 className="title" >Custom Attributes</h2> 
            <div style={{backgroundColor:"#f4f4f4",padding:"10px",width:"1560px",margin:"0 auto"}}>
            <div className="search">
              <div className="row align-items-center">
                
                  <div className="col-md-6 d-flex justify-content-start">
                          <input
                            type="text"
                            id="searchInput"
                            className="form-control"
                            placeholder="Search..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                          />
                          </div>
                      
                      <div className="col-md-6 d-flex justify-content-end">
                        <Link
                          to="/addCustomAttributes" // Replace "/path/to/add" with the actual path you want to link to for adding
                          className="btn btn-primary"
                          style={{backgroundColor:"#004aad",borderColor:"#004aad"}}
                        >
                          Add
                        </Link>
                      </div>
                    </div>
                  </div>
            <div style={{ height: 400, width: '100%', position: 'relative', marginTop: '2%',background:'#f0f0f5'  }}>
              <DataGrid
                rows={filteredRows}
                columns={columns}
                pageSize={5}
                rowSelected={selectedRowId !== null}
                onRowClick={(row) => handleRowClick(row.id)}
                components={{
                  Toolbar: () => null,  
                }}
                sx={{
                  '& .MuiDataGrid-columnHeaderTitle': {
                    fontWeight: 'bold',
                  }, 
                  '& .MuiDataGrid-cell:focus': {
                    outline: 'none',  
                  },
                  '& .MuiDataGrid-cell:focus-within': {
                    outline: 'none',  
                  },
                }}
              />
              {selectedRowId !== null && (
                <div
                  style={{
                    position: 'absolute',
                    top: rows.findIndex(row => row.id === selectedRowId) * 52 + 48,
                    right: '10px',
                    display: 'flex',
                    marginTop:'15px'
                  }}
                >
                  <button
                    style={{
                      padding: '8px 16px',
                      backgroundColor: '#0d6efd', // Updated button color
                      color: 'white',
                      border: 'none',
                      borderRadius: '4px',
                     cursor: 'pointer',
                      marginRight: '5px',
                    }}
                    onClick={() => handleEdit(selectedRowId)}
                  >
                    Edit
                  </button>
                  <button
                    style={{
                      padding: '8px 16px',
                      backgroundColor: '#0d6efd', // Updated button color
                      color: 'white',
                      border: 'none',
                      borderRadius: '4px',
                    cursor: 'pointer',
                      
                    }}
                    onClick={() => handleDelete(selectedRowId)}
                  >
                    Delete
                  </button>
                </div>
              )}
            </div>
            </div>
          </div>
  );
};

export default CustomAttributes;
